import * as React from 'react';
import { styled } from '@mui/material/styles';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import { AppContext } from '../../context/AppContext';
import { ViewImage } from '../../pages/Suppliers/ViewImage';
import { AddTax } from '../../pages/Suppliers/AddTax';

export interface BakeasyDialogProps {
  dialog?: BakeasyDialogProp;
}

export interface BakeasyDialogProp {
  isDelete?: boolean | false;
  open?: boolean;
  title?: string;
  message?: string;
  dialogContent?: any;
  onYesClick?: (event: React.MouseEvent<HTMLButtonElement>, param?: string) => void;
  onNoClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  fetchData?: () => void;
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': { padding: theme.spacing(2) },
  '& .MuiDialogActions-root': { padding: theme.spacing(1) }
}));

export default function BakeasyDialog(props: BakeasyDialogProps) {
  let myContext = React.useContext(AppContext);
  const [maxWidth, setMaxWidth] = React.useState<DialogProps['maxWidth']>('sm');

  function handleOnClose() {
    myContext.setDialog({ open: false });
  }

  function renderUI(pageName: string) {
    switch (pageName) {
      case 'AddEditSupplier':
        return <>{renderAddEditSupplier()}</>;
      case 'AddTax':
        return <>{renderAddTax()}</>;
      case 'ViewImage':
        return <>{renderViewImage()}</>;
    }
  }

  function renderAddEditSupplier() {
    return <></>;
  }

  function renderViewImage() {
    return <ViewImage {...props?.dialog?.dialogContent} />;
  }

  function renderAddTax() {
    return <AddTax {...props?.dialog?.dialogContent}></AddTax>;
  }

  return (
    <React.Fragment>
      <BootstrapDialog
        fullWidth={maxWidth === 'sm'}
        maxWidth={maxWidth}
        onClose={handleOnClose}
        aria-labelledby="customized-dialog-title"
        open={props?.dialog?.open ? props?.dialog?.open : false}
      >
        {renderUI(props?.dialog?.dialogContent?.pageName)}
      </BootstrapDialog>
    </React.Fragment>
  );
}
